import { createAsyncThunk } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';
import { graphqlRequest } from '~/adapters/graphqlRequest';
import {
  DeleteLifecycleSurveyTriggerDocument,
  DeleteLifecycleSurveyTriggerMutationResult,
  GetLifecycleSurveyTriggersDocument,
  InputLifecycleSurveyTrigger,
  UpsertLifecycleSurveyTriggerDocument,
  UpsertLifecycleSurveyTriggerMutationResult,
} from '~/gql/graphql';
import * as schemas from '../schemas';
import { lifecycleSurveyTriggerTransformer } from '../transformers/lifecycleSurveyTrigger.transformer';

const upsertLifecycleSurveyTrigger = createAsyncThunk(
  'lifecycleSurveys/upsertLifecycleSurveyTrigger',
  async (params: InputLifecycleSurveyTrigger, { rejectWithValue }) => {
    try {
      const res = await graphqlRequest<UpsertLifecycleSurveyTriggerMutationResult>(
        UpsertLifecycleSurveyTriggerDocument,
        {
          lifecycleSurveyTrigger: params,
        },
      );

      if (!res.data?.upsertLifecycleSurveyTrigger) return rejectWithValue(res);

      const transformed = lifecycleSurveyTriggerTransformer(res.data.upsertLifecycleSurveyTrigger);

      return normalize([transformed], [schemas.lifecycleSurveyTrigger]);
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const getLifecycleSurveyTriggers = createAsyncThunk(
  'lifecycleSurveys/getLifecycleSurveyTriggers',
  async (_, { rejectWithValue }) => {
    try {
      const res = await graphqlRequest<any>(GetLifecycleSurveyTriggersDocument);

      if (!res.data?.getLifecycleSurveyTriggers?.length) return rejectWithValue(res);

      const transformed = res.data.getLifecycleSurveyTriggers.map(lifecycleSurveyTriggerTransformer);

      return normalize(transformed, [schemas.lifecycleSurveyTrigger]);
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const deleteLifecycleSurveyTrigger = createAsyncThunk(
  'lifecycleSurveys/deleteLifecycleSurveyTrigger',
  async (
    { id, shouldClearPendingEmployees }: { id: number; shouldClearPendingEmployees: boolean },
    { rejectWithValue },
  ) => {
    try {
      const res = await graphqlRequest<DeleteLifecycleSurveyTriggerMutationResult>(
        DeleteLifecycleSurveyTriggerDocument,
        {
          id,
          shouldClearPendingEmployees,
        },
      );

      if (!res.data?.deleteLifecycleSurveyTrigger?.success) return rejectWithValue(res);

      return { id };
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const lifecycleSurveyTriggerActions = {
  upsertLifecycleSurveyTrigger,
  getLifecycleSurveyTriggers,
  deleteLifecycleSurveyTrigger,
};
